import { render, staticRenderFns } from "./NeedStartupSubmitModal.vue?vue&type=template&id=7d042abc&scoped=true&"
import script from "./NeedStartupSubmitModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedStartupSubmitModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d042abc",
  null
  
)

export default component.exports